import {Geocoding} from "./geocoding";
import {OrganizationType} from "./organization-type";

export class OrganizationSummary {
  organizationUuid: string;
  orgCode: string;
  parentCode: string;
  name: string;
}

export class Organization extends OrganizationSummary {
  email: string;
  description?: string;
  organizationType: OrganizationType;
  parentUuid: string;
  totalSqueezedFruits: number;
  parent: Organization;
  address?: string;
  zip?: string;
  phone?: string | object;
  longitude?: number;
  latitude?: number;
  geocoding?: Geocoding;
  totalMachines: number;
  mailLanguage: string;
  mailTimezone: string;
  additionalMails: string[];
}

